<div class="col-12">
  <mvs-crud-object
    [objectId]="objectId"
    [objectType]="objectType"
    [formFooterButtons]="formFooterButtons"
    [importObjectContextDto]="importObjectContextDto"
    (onFooterButtonClick)="handleButtonClick($event)"
  ></mvs-crud-object>

</div>

<div class="col-12">

  <mvs-widget
    [widgetData]="tableWidget"
    [importObjectContext]="importObjectContextDto"
  ></mvs-widget>


</div>
